import mixitup from 'mixitup';

export function initCataloguesModule() {

    if (document.querySelector('.catalogues-mixer') === null) {
        return;
    }

    // console.log('Inizializzazione modulo Catalogues con MixItUp');

    const containerEl = document.querySelector('.catalogues-mixer');

    const mixer = mixitup(containerEl, {
        selectors: {
            target: '.catalogue-item',
        },
        animation: {
            duration: 300
        },
        debug: { enable: true }
    });

    document.querySelectorAll('.catalogues-filter-item').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const filterValue = button.getAttribute('href');
            const isActive = button.classList.contains('active');

            if (isActive) {
                // Se già attivo, rimuovi filtro e stato attivo
                mixer.filter('all');
                button.classList.remove('active');
            } else {
                // Applica filtro e aggiorna stato attivo
                mixer.filter(filterValue);
                document.querySelectorAll('.catalogues-filter-item').forEach(btn => {
                    btn.classList.remove('active');
                });
                button.classList.add('active');
            }
        });
    });

}